export default __webpack_public_path__ + "locales/si/SmartBanner.json?hash=025df42473ee56618fad7c589f179af6";